import { FLINT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITextInput from 'UIComponents/input/UITextInput';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getDataAttributes } from '../utils/getDataAttributes';

// We narrow the props down here so we can use this in the formatter as well
// without specifying all the props possible on the input. Props should never be
// added here that are not provided in PropertyInputV2
import { jsx as _jsx } from "react/jsx-runtime";
const renderTooltipTitle = property => {
  if (property && property.label) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputHidden.noPermissionWithLabel",
      options: {
        propertyLabel: property.label
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputHidden.noPermission"
  });
};
const PropertyInputHidden = props => {
  if (props.formControlUse === 'compact') {
    return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
      children: /*#__PURE__*/_jsx(UITextInput, {
        disabled: true
      })
    }));
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: renderTooltipTitle(props.property),
      autoPlacement: true,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "hide",
        size: "xxs",
        color: FLINT
      })
    })
  }));
};
export default /*#__PURE__*/memo(PropertyInputHidden);